<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <!-- <el-breadcrumb>
            <div class="mainBread">
              <el-breadcrumb-item>{{
                $t("menu.Home_View")
              }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{
                $t("menu.DeviceStatistics_View")
              }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{
                $t("menu.MobileSIMManagement_View")
              }}</el-breadcrumb-item>
            </div>
          </el-breadcrumb> -->
          <nav-bar></nav-bar>

          <div class="SIMDiv" style="margin-top: 20px">
            <el-row :gutter="24">
              <el-col :lg="6" :md="6" :sm="12" :xs="24">
                <div class="block" :style="topHeight">
                  <h4>{{ $t("sim.TotalSIMCards") }}</h4>
                  <span
                    >{{ simNums.simTotal
                    }}<small>{{ $t("sim.sheet") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="6" :md="6" :sm="12" :xs="24">
                <div class="block" :style="topHeight">
                  <h4>{{ $t("sim.CostOfLastMonth") }}</h4>
                  <span
                    >{{ lastInvoiceAmount
                    }}<small>{{ $t("sim.yuan") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="6" :md="6" :sm="12" :xs="24">
                <div class="block" :style="topHeight">
                  <h4>{{ $t("sim.DataThisMonth") }}</h4>
                  <span>{{ useAmount }}<small>GB</small></span>
                </div>
              </el-col>
              <el-col :lg="6" :md="6" :sm="12" :xs="24">
                <div class="block" :style="topHeight">
                  <h4>{{ $t("sim.SimDetails") }}</h4>
                  <el-button
                    type=""
                    @click="showInfo"
                    style="margin: 10px auto 0; display: block"
                    >{{ $t("sim.ClickToViewDetails") }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="7" :md="7" :sm="12" :xs="24">
                <div class="block" :style="highHeight">
                  <h4 style="color:#fff;">{{ $t("sim.SIMActivationStatus") }}</h4>
                  <div class="homeline" id="SIMState" :style="highEchart"></div>
                </div>
              </el-col>

              <el-col :lg="7" :md="7" :sm="12" :xs="24">
                <div class="block" :style="highHeight">
                  <h4 style="color:#fff;">{{ $t("sim.ExpensesInRecentSixMonths") }}</h4>
                  <div class="homeline" id="CostBar" :style="highEchart"></div>
                </div>
              </el-col>
              <el-col :lg="10" :md="10" :sm="24" :xs="24">
                <div class="block" :style="lowHeight">
                  <h4 style="color:#fff;">{{ $t("sim.TrafficUsageInRecentSevendays") }}</h4>
                  <div
                    class="homeline"
                    id="SIMTrafficDay"
                    :style="lowEchart"
                  ></div>
                </div>
                <div class="block" :style="lowHeight">
                  <h4 style="color:#fff;">{{ $t("sim.TrafficUsageInRecentSixMonths") }}</h4>
                  <div
                    class="homeline"
                    id="SIMTrafficMonth"
                    :style="lowEchart"
                  ></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog
      :title="$t('sim.SimDetails')"
      :visible.sync="dialogInfo"
      width="80%"
      top="5%"
      class="abow_dialog"
      @close="closeDialog"
    >
      <el-form
        ref="ccnform"
        :model="ccnform"
        class="queryform_div"
        label-width="90px"
      >
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="12" :lg="7">
            <el-form-item :label="$t('sim.simNo')">
              <el-input
                v-model="ccnform.simCardNo"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="7">
            <el-form-item :label="$t('sim.simStatus')">
              <el-select
                v-model="ccnform.simStatus"
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option value="all" :label="$t('desc.all')"></el-option>
                <el-option value="2" :label="$t('sim.Activated')"></el-option>
                <el-option value="1" :label="$t('sim.NotActive')"></el-option>
                <el-option value="4" :label="$t('sim.Shutdown')"></el-option>
                <el-option value="6" :label="$t('sim.Testable')"></el-option>
                <el-option value="7" :label="$t('sim.Stock')"></el-option>
                <el-option
                  value="8"
                  :label="$t('sim.PreCancellation')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="10">
            <el-form-item :label="$t('title.Datefrom')">
              <el-date-picker
                v-model="ccnform.time"
                type="monthrange"
                align="right"
                unlink-panels
                :range-separator="$t('title.to')"
                :start-placeholder="$t('title.beginDate')"
                :end-placeholder="$t('title.endDate')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" >
            <el-button type="primary" @click="getData('search')" size="small">{{
              $t("button.query")
            }}</el-button>
            <el-button @click="reset" size="small">{{
              $t("button.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <template>
        <div class="tableDiv">
        <el-table
          :data="tableData1"
          stripe
          v-loading="loading"
          style="width: 100%"
          :empty-text="$t('desc.noData')"
        >
          <el-table-column
            type="index"
            :label="$t('title.serialNumber')"
            width="55"
          >
          </el-table-column>
          <el-table-column
            prop="simCardNo"
            :label="$t('sim.simNo')"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            prop="simStatus"
            :label="$t('sim.simStatus')"
            min-width="100px"
          >
            <template slot-scope="scope">
              <label v-if="scope.row.simStatus == '1'">{{
                $t("sim.NotActive")
              }}</label>
              <label v-if="scope.row.simStatus == '2'">{{
                $t("sim.Activated")
              }}</label>
              <label v-if="scope.row.simStatus == '4'">{{
                $t("sim.Shutdown")
              }}</label>
              <label v-if="scope.row.simStatus == '6'">{{
                $t("sim.Testable")
              }}</label>
              <label v-if="scope.row.simStatus == '7'">{{
                $t("sim.Stock")
              }}</label>
              <label v-if="scope.row.simStatus == '8'">{{
                $t("sim.PreCancellation")
              }}</label>
            </template>
          </el-table-column>
          <el-table-column
            prop="snNo"
            :label="$t('sim.bindSnNo')"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            prop="iotNo"
            :label="$t('sim.gatewayNo')"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            prop="curMonthDataAmout"
            :label="$t('sim.monthlyFlow') + '(KB)'"
            min-width="100px"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="currMonthCost"
            :label="$t('sim.monthlyFee') + '(' + $t('sim.yuan') + ')'"
            min-width="100px"
          >
          </el-table-column> -->
          <el-table-column
            prop="months"
            :label="$t('sim.month')"
            min-width="100px"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.totalPage"
          :current-page.sync="pagination.current"
          :page-size="pagination.pageSize"
          @current-change="getData()"
          style="text-align: center; margin-top: 10px"
        ></el-pagination>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  GetSimStatusNumber,
  UpdateMesIsRead,
  GetCurrenSixMonthBill,
  GetBill,
  GetUseAmout,
  GetSimDataUsagemonthlyBatch,
  GetSimDataUsagemDailyBatch,
  GetSimInfoDetail,
} from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    //SIM状态数OPTIONS
    stateOptions() {
      let pointActive = parseInt(this.simNums.actNum); //已激活数
      let pointLoad = parseInt(this.simNums.readyNum); //待激活
      let pointDown = parseInt(this.simNums.suspendNum); //已停机
      let testNum = parseInt(this.simNums.testNum); //可测试
      let inactNum = parseInt(this.simNums.inactNum); //库存数
      let preTerNum = parseInt(this.simNums.preTerNum); //预销户
      let handred =
        pointActive + pointLoad + pointDown + testNum + inactNum + preTerNum; //总SIM卡数

      let pointOther = handred - pointActive - pointLoad - pointDown; //其他
      let t0 = this.$t("sim.Activated");
      let t1 = this.$t("sim.NotActive");
      let t2 = this.$t("sim.Shutdown");
      let t3 = this.$t("sim.other");
      let optionSIMState = {
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          data: [
            t0 + pointActive,
            t1 + pointLoad,
            t2 + pointDown,
            t3 + pointOther,
          ],
          bottom: 1,
          left: "center",
          height: 50,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#828393",
            fontSize: 12,
            lineHeight: 20,
            fontFamily: "Arial",
          },
          itemGap: 5,
          formatter: function (params) {
            return params;
          },
        },
        series: [
          {
            name: "circle",
            type: "pie",
            clockWise: true,
            center: ["50%", "40%"],
            radius: ["60%", "72%"],
            hoverAnimation: false,
            cursor: "default",
            data: [
              {
                value: pointActive,
                name: t0 + pointActive,
                label: {
                  position: "center",
                  fontFamily: "Arial",
                  formatter: ["{a|{c}}", "{b|{b}}"].join("\n"),
                  rich: {
                    a: {
                      color: "#fff",
                      lineHeight: 40,
                      fontSize: 24,
                      fontWeight: "bold",
                      fontFamily: "Arial",
                    },
                    b: {
                      color: "#828393",

                      fontSize: 14,
                      fontFamily: "Arial",
                    },
                  },
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  normal: {
                    color: "#6390B9",
                  },
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
              },
              {
                name: t1 + pointLoad,
                value: pointLoad,
                itemStyle: {
                  normal: {
                    color: "#EECA3F",
                  },
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
              },
              {
                name: t2 + pointDown,
                value: pointDown,
                itemStyle: {
                  normal: {
                    color: "#E1523D",
                  },
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
              },
              {
                name: t3 + pointOther,
                value: pointOther,
                itemStyle: {
                  normal: {
                    color: "#E5E5E5",
                  },
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
              },
            ],
          },
        ],
      };
      return optionSIMState;
    },
    //近6月费用OPTIONS
    sixBillOptions() {
      let dataLine = this.billInfos; //[this.sixBill[0].invoiceAmount,this.sixBill[1].invoiceAmount,this.sixBill[2].invoiceAmount,this.sixBill[3].invoiceAmount,this.sixBill[4].invoiceAmount,this.sixBill[5].invoiceAmount];
      let timeLine = this.yearMonthList;
      //[
      //   //最近6个月
      //   this.$t("el.datepicker.months.jul"),
      //   this.$t("el.datepicker.months.aug"),
      //   this.$t("el.datepicker.months.sep"),
      //   this.$t("el.datepicker.months.oct"),
      //   this.$t("el.datepicker.months.nov"),
      //   this.$t("el.datepicker.months.dec"),
      // ];
      let tcost = this.$t("sim.cost") + "(" + this.$t("sim.yuan") + ")";
      let optionCostBar = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        legend: {
          icon: "roundRect",
          orient: "horizontal",
          data: [tcost],
          top: "-8",
          left: 0,
          itemWidth: 16,
          itemHeight: 6,
          textStyle: {
            color: "#828393",
            fontSize: 12,
            lineHeight: 44,
            fontFamily: "Arial",
          },
          itemGap: 5,
        },
        grid: {
          top: 40,
          left: 45,
          right: 20,
          bottom: 30,
        },
        xAxis: [
          {
            type: "category",
            data: timeLine,
            interval: 0,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#3A3D46",
              },
            },
          },
        ],

        series: [
          {
            name: tcost,
            type: "bar",
            barWidth: "35%",
            data: dataLine,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              fontFamily: "Arial",
              color: "#fff",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [100, 100, 0, 0],
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(99,144,185,1)" },
                  { offset: 0.7, color: "rgba(99,144,185,0.7)" },
                  { offset: 1, color: "rgba(99,144,185,0.5)" },
                ]),
              },
            },
          },
        ],
      };
      return optionCostBar;
    },
    sixMonthsDataOptin() {
      let dataLine = this.sixMothsData;
      let timeLine = this.dataMonthList;
      // [
      //   //最近6个月

      //   this.$t("el.datepicker.months.jul"),
      //   this.$t("el.datepicker.months.aug"),
      //   this.$t("el.datepicker.months.sep"),
      //   this.$t("el.datepicker.months.oct"),
      //   this.$t("el.datepicker.months.nov"),
      //   this.$t("el.datepicker.months.dec"),
      // ];
      let tflow = this.$t("sim.flow");
      let optionSIMTrafficMonth = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        legend: {
          icon: "roundRect",
          orient: "horizontal",
          data: [tflow + " (GB) "],
          top: "-8",
          left: 0,
         itemWidth:16,
          itemHeight: 6,
          textStyle: {
            color: "#828393",
            fontSize: 12,
            lineHeight: 20,
          },
          itemGap: 5,
        },
        grid: {
          top: 30,
          left: 30,
          right: 0,
          bottom: 30,
        },
        xAxis: [
          {
            color: "#828393",
            data: timeLine, 
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 2,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#3A3D46",
              },
            },
          },
        ],
        series: [
          {
            name: tflow + " (GB) ",
            type: "line",
            smooth: true, //是否平滑
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              normal: {
                color: "rgba(99,144,185,1)",
              },
            },
            itemStyle: {
              color: "rgba(99,144,185,1)", 
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(99,144,185,0.5)" },
                  { offset: 1, color: "rgba(99,144,185,0)" },
                ]),
              },
            },
            data: dataLine,
          },
        ],
      };
      return optionSIMTrafficMonth;
    },
    sevenDaysDataOptions() {
      let dataLine = this.sevenDaysData; //[1.32, 1.158, 1.258, 1.356, 1.3123, 1.852, 1.199];
      let timeLine = this.dataDaysList;
      //  [
      //   "01-25",
      //   "01-26",
      //   "01-27",
      //   "01-28",
      //   "01-29",
      //   "01-30",
      //   "01-31",
      // ];
      let tflow = this.$t("sim.flow");
      let optionSIMTrafficDay = {
       tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        legend: {
          icon: "roundRect",
          orient: "horizontal",
          data: [tflow + " (GB) "],
          top: "-8",
          left: 0,
          itemWidth:16,
          itemHeight: 6,
          textStyle: {
            color: "#999",
            fontSize: 12,
            lineHeight: 20,
          },
          itemGap: 5,
        },
        grid: {
          top: 30,
          left: 30,
          right: 0,
          bottom: 30,
        },
        xAxis: [
          {
            color: "#828393",
            data: timeLine,

            boundaryGap: false,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 2,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#3A3D46",
              },
            },
          },
        ],
        series: [
          {
            name: tflow + " (GB) ",
            type: "line",
            smooth: true, //是否平滑
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              normal: {
                color: "rgba(99,144,185,1)",
              },
            },
            itemStyle: {
              color: "rgba(99,144,185,1)", 
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(99,144,185,0.5)" },
                  { offset: 1, color: "rgba(99,144,185,0)" },
                ]),
              },
            },
            data: dataLine,
          },
        ],
      };
      return optionSIMTrafficDay;
    },
  },
  data() {
    return {
      loading: false,
      dialogInfo: false,

      ccnform: {
        time: [],
      },
      tableData1: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      topHeight: {
        height: "",
        minHeight: "60px",
        maxHeight: "90px",
      },
      highHeight: {
        height: "",
        minHeight: "264px",
        maxHeight: "520px",
      },
      highEchart: {
        height: "",
        minHeight: "234px",
        maxHeight: "490px",
      },
      lowHeight: {
        height: "",
        minHeight: "92px",
        maxHeight: "221px",
      },
      lowEchart: {
        height: "",
        minHeight: "62px",
        maxHeight: "191px",
      },
      //SIM状态
      simNums: {
        testNum: 0,
        readyNum: 0,
        inactNum: 0,
        actNum: 0,
        suspendNum: 0,
        preTerNum: 0,
        simTotal: 0,
      },
      sixBill: [],
      billInfos: [],
      yearMonthList: [],
      //上月费用
      lastInvoiceAmount: "",
      //本月流量使用量
      useAmount: "",
      //6个月流量数据
      sixMothsData: [],
      dataMonthList: [],
      //近7日流量数据
      sevenDaysData: [],
      dataDaysList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
    };
  },
  mounted() {
    this.GetSimStatus();
    this.GetSixBill();
    this.GetLastInvoiceAmount();
    this.GetCurMonAmout();
    this.GetSimDataBySixMonths();
    this.GetSimDataBySevenDays();
  },
  methods: {
    //获取SIM状态数
    async GetSimStatus() {
      await GetSimStatusNumber().then((res) => {
        if (res.success) {
          this.simNums = res.result[0];
          this.simNums.simTotal =
            parseInt(this.simNums.actNum) +
            parseInt(this.simNums.readyNum) +
            parseInt(this.simNums.suspendNum) +
            parseInt(this.simNums.testNum) +
            parseInt(this.simNums.inactNum) +
            parseInt(this.simNums.preTerNum);
          this.$nextTick(() => {
            this.initSIMState();
          });
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //近6月费用
    async GetSixBill() {
      let monthNum = 6;
      await GetCurrenSixMonthBill(monthNum).then((res) => {
        if (res.success) {
          this.sixBill = res.result;
          for (let i = 0; i < this.sixBill.length; i++) {
            this.billInfos.push(this.sixBill[i].invoiceAmount);

            this.yearMonthList.push(this.sixBill[i].yearMonth);
          }

          this.$nextTick(() => {
            this.initCostBar();
          });
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //上月费用
    async GetLastInvoiceAmount() {
      var date = new Date();
      var currym = "";
      var monthstr = "";
      if (date.getMonth() == 0) {
        currym = `${date.getFullYear() - 1}${0}${12}`;
      } else if (date.getMonth() > 0 && date.getMonth() < 10) {
        monthstr = `${0}${date.getMonth()}`;
        currym = `${date.getFullYear()}${monthstr}`;
      } else {
        currym = `${date.getFullYear()}${date.getMonth()}`;
      }
      let queryDate = currym;
      await GetBill(queryDate).then((res) => {
        if (res.success) {
          this.lastInvoiceAmount = res.result[0].invoiceAmount;
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //本月流量
    async GetCurMonAmout() {
      await GetUseAmout().then((res) => {
        if (res.success) {
          this.useAmount = res.result;
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //近6个月流量
    async GetSimDataBySixMonths() {
      await GetSimDataUsagemonthlyBatch().then((res) => {
        if (res.success) {
          res.result;
          for (let i = 0; i < res.result.length; i++) {
            this.sixMothsData.push(
              parseFloat(res.result[i].dataAmount / (1024 * 1024)).toFixed(3)
            );
            this.dataMonthList.push(res.result[i].months);
          }
          this.$nextTick(() => {
            this.initSIMTrafficMonth();
          });
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //近7日流量
    async GetSimDataBySevenDays() {
      await GetSimDataUsagemDailyBatch().then((res) => {
        if (res.success) {
          res.result;
          for (let i = 0; i < res.result.length; i++) {
            this.sevenDaysData.push(
              parseFloat(res.result[i].dataAmount / (1024 * 1024)).toFixed(3)
            );
            this.dataDaysList.push(res.result[i].days);
          }
          this.$nextTick(() => {
            this.initSIMTrafficDay();
          });
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    SetHeight() {
      var mHeight = window.innerHeight - 135; //总高
      this.topHeight.height = mHeight / 5 - 60 + "px";
      this.highHeight.height = (4 * mHeight) / 5 - 60 + "px";
      this.highEchart.height = (4 * mHeight) / 5 - 75 + "px";
      this.lowHeight.height = (4 * mHeight) / 5 / 2 - 68 + "px";
      this.lowEchart.height = (4 * mHeight) / 5 / 2 - 83 + "px";
    },
    getNowDate() {},
    showInfo() {
      var date = new Date();
      var currym = "";
      var monthstr = "";
      if (date.getMonth() == 0) {
        currym = `${date.getFullYear() - 1}${0}${12}`;
      } else if (date.getMonth() > 0 && date.getMonth() < 10) {
        monthstr = `${0}${date.getMonth()}`;
        currym = `${date.getFullYear()}${monthstr}`;
      } else {
        currym = `${date.getFullYear()}${date.getMonth()}`;
      }
      this.ccnform.time[0] = date;
      this.ccnform.time[1] = date;

      this.dialogInfo = true;
      this.getData();
    },
    initSIMState() {
      var SIMState = this.$echarts.init(document.getElementById("SIMState"));
      SIMState.setOption(this.stateOptions);
      window.addEventListener("resize", () => {
        SIMState.resize();
      });
    },
    initCostBar() {
      var CostBar = this.$echarts.init(document.getElementById("CostBar"));
      CostBar.setOption(this.sixBillOptions);
      window.addEventListener("resize", () => {
        CostBar.resize();
      });
    },
    initSIMTrafficDay() {
      var SIMTrafficDay = this.$echarts.init(
        document.getElementById("SIMTrafficDay")
      );

      SIMTrafficDay.setOption(this.sevenDaysDataOptions);

      window.addEventListener("resize", () => {
        SIMTrafficDay.resize();
      });
    },
    initSIMTrafficMonth() {
      var SIMTrafficMonth = this.$echarts.init(
        document.getElementById("SIMTrafficMonth")
      );

      SIMTrafficMonth.setOption(this.sixMonthsDataOptin);

      window.addEventListener("resize", () => {
        SIMTrafficMonth.resize();
      });
    },

    getData(type = "normal") {
      if (type == "search") {
        this.pagination.current = 1;
      }
      this.loading = true;
      var data = this.ccnform;
      data.SkipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      data.MaxResultCount = this.pagination.pageSize;

      GetSimInfoDetail(data).then((res) => {
        if (res.success) {
          this.pagination.totalPage = res.result.totalCount;
          this.tableData1 = res.result.items;
          this.loading = false;
        }
      });
    },
    reset() {
      this.ccnform.time = [];
      this.ccnform.simCardNo = "";
      this.ccnform.simStatus = "";
      var date = new Date();
      this.ccnform.time[0] = date;
      this.ccnform.time[1] = date;
      this.getData();
    },
    closeDialog() {
      this.reset();
    },
  },
  created() {
    window.addEventListener("resize", this.SetHeight);

    var _self = this;
    this.$nextTick(() => {
      _self.SetHeight();
      setTimeout(() => {
        // _self.initSIMState();
        _self.initCostBar();
        _self.initSIMTrafficDay();
        _self.initSIMTrafficMonth();
      }, 100);
    });
  },
};
</script>


